import { SelectOptionGroups } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { ExportScheduleByOpts } from 'modules/shift_management/lib/types'

// By using this type we:
// - We maintain the API contract
// - We ensure that all the API compatible options are covered
type Options = {
  [key in ExportScheduleByOpts]: string
}

export const exportScheduleGroupByOptions = (): SelectOptionGroups => {
  const options: Options = {
    current_filters: i18n.t(
      'shift_management.export_shifts.form.export_by.options.current_filters'
    ),
    teams: i18n.t('shift_management.export_shifts.form.export_by.options.teams'),
    managers: i18n.t('shift_management.export_shifts.form.export_by.options.managers'),
    workplaces: i18n.t('shift_management.export_shifts.form.export_by.options.workplaces'),
  }

  return Object.entries(options).map(([key, value]) => {
    return {
      value: key,
      label: value,
    }
  })
}
